<div class="row">
  <div class="col">
    <div class="row mb-2" *ngIf="activeChips && activeChips.length > 0">
      <div class="d-flex flex-wrap gap-2">
        <it-chip *ngFor="let chip of activeChips" [showCloseButton]="true" [color]="'warning'" [label]="chip.label"
          (closeEvent)="removeFilterField(chip.key)"></it-chip>
      </div>
    </div>
  </div>
  <div class="col-2 text-end no-print">
    <button itButton="outline-warning" [size]="'xs'" data-bs-toggle="modal" data-bs-target="#filterModal">
      <it-icon name="search"></it-icon> Filtra ricerca
    </button>
  </div>
</div>

<it-modal size="xl" #rightModal="itModal" alignment="right" scrollable="true" id="filterModal"
  (hidden.bs.modal)="onModalClosed()">
  <ng-container modalTitle>Filtri ricerca</ng-container>

  <p></p>
  <form [formGroup]="formFilters">
    <div class="mb-2">
      <it-card teaser="true" shadow="true">
        <div class="row">
          <div class="col-md-6" >
            <it-input label="Codice Fiscale" [type]="'text'" formControlName="patientFiscalCode" [disabled]="operatoreMMg"></it-input>
          </div>
          <div class="col-md-6">
            <it-input label="Numero pratica" [type]="'text'" formControlName="code"></it-input>
          </div>
          <div class="col-md-6">
            <it-input label="Nome paziente" [type]="'text'" formControlName="patientName"></it-input>
          </div>
          <div class="col-md-6">
            <it-input label="Cognome Paziente" [type]="'text'" formControlName="patientSurname"></it-input>
          </div>
          <div class="col-md-6">
            <it-input
              label="Data richiesta da"
              type="date"
              formControlName="startDate"
            ></it-input>
          </div>
          <div class="col-md-6">
            <it-input
              label="Data richiesta a"
              type="date"
              formControlName="endDate"
            ></it-input>
          </div>
        </div>
      </it-card>
    </div>

    <div class="mb-2">
      <it-card teaser="true" shadow="true">
        <div class="row">
          <div class="col">
            <fieldset>
              <legend>Stato della richiesta 
                <a href="#" (click)="selectAllStatuses($event)">Seleziona tutti</a> |
                <a href="#" (click)="deselectAllStatuses($event)">Deseleziona tutti</a>
              </legend>

              <div *ngFor="let status of requestStatusOptions" class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" [id]="status.value" [value]="status.value"
                  [checked]="formFilters.get('statusCodes')?.value?.includes(status.value)"
                  (change)="onCheckboxChange($event, status.value)" />
                <label class="form-check-label" [for]="status.value">{{ status.label }}</label>
              </div>
            </fieldset>
          </div>
        </div>
      </it-card>
    </div>
  </form>
  <div class="mb-2" *ngIf="authService.isOperatoreSuperUser">
    <it-card teaser="true" shadow="true">
      <div class="row">
        <div class="col mt-4">
          <p class="example-section">
            <it-select id="default-select" label="Asl" [(ngModel)]="selectedAsl"
              defaultOption="Seleziona un elemento" (ngModelChange)="onSelectedAsl($event)">
              <option [value]="null">Seleziona un elemento</option>
              <option *ngFor="let asl of asls" [value]="asl.code">
                {{ asl.name }}
              </option>
            </it-select>
          </p>
        </div>
      </div>
    </it-card>
  </div>

  <div class="mb-2">
    <it-card teaser="true" shadow="true">
      <div class="row">
        <div class="col mt-4">
          <p class="example-section">
            <it-select id="default-select" label="Setting" [(ngModel)]="selectedSetting"
              defaultOption="Seleziona un elemento" (ngModelChange)="onSelectedSetting($event)">
              <option [value]="null">Seleziona un elemento</option>
              <option *ngFor="let setting of settings" [value]="setting.code">
                {{ setting.name }}
              </option>
            </it-select>
          </p>
        </div>
      </div>
    </it-card>
  </div>

  <ng-container footer>
    <button itButton="primary" size="lg" type="button" (click)="onSubmitFilters()">
      Cerca
    </button>
    <button itButton="outline-primary" size="lg" type="button" data-bs-dismiss="modal">
      Chiudi
    </button>
  </ng-container>
</it-modal>